import * as React from 'react';

const Link24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M6.41856 7.30156C8.36273 5.22381 11.537 5.22362 13.4811 7.30156C15.3983 9.35115 15.3982 12.6553 13.4811 14.7049C13.1981 15.0074 12.723 15.023 12.4205 14.74C12.1181 14.457 12.1024 13.9819 12.3854 13.6795C13.763 12.2064 13.7632 9.79882 12.3854 8.32598C11.034 6.88179 8.86459 6.88179 7.51328 8.32598L3.78379 12.3133C2.40617 13.7863 2.40598 16.1939 3.78379 17.6668C5.13511 19.1112 7.30449 19.1111 8.65586 17.6668C8.93869 17.3647 9.41298 17.3483 9.71543 17.6307C10.0178 17.9135 10.0342 18.3887 9.75157 18.6912C7.80746 20.7693 4.63325 20.7692 2.68907 18.6912C0.771643 16.6415 0.771584 13.3375 2.68907 11.2879L6.41856 7.30156ZM14.2496 5.3084C16.1937 3.2305 19.368 3.23057 21.3121 5.3084C23.2296 7.35801 23.2295 10.662 21.3121 12.7117L17.5826 16.698C15.6384 18.776 12.4642 18.7761 10.5201 16.698C8.60291 14.6484 8.6028 11.3443 10.5201 9.29473C10.8031 8.99243 11.2782 8.97672 11.5807 9.25957C11.8831 9.5425 11.8986 10.0176 11.6158 10.3201C10.2381 11.7931 10.238 14.2007 11.6158 15.6736C12.9672 17.118 15.1366 17.118 16.4879 15.6736L20.2174 11.6863C21.5949 10.2133 21.5952 7.80562 20.2174 6.33281C18.8661 4.88856 16.6967 4.8887 15.3453 6.33281C15.0625 6.63514 14.5882 6.65147 14.2857 6.36894C13.9834 6.08601 13.9668 5.61086 14.2496 5.3084Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export default Link24;
